import mockImage from '../../../../../../../../assets/images/food-mock.png';
import { Container } from '../../../../../../../../components/container/container';
import { InputFileSquare } from '../../../../../../../../components/input-file/input-file-square/input-file-square';
import { Input } from '../../../../../../../../components/input/input';
import { Label } from '../../../../../../../../components/label/label';
import { LangInput } from '../../../../../../../../features/lang-input/lang-input';
import s from './menu-informer-create-dish-modal-step-1.module.css';
import { useMenuInformerCreateDishModalStep1 } from './use-menu-informer-create-dish-modal-step-1';

export const MenuInformerCreateDishModalStep1 = () => {
  const {
    dish,
    focusRef,
    handleChangeActualCost,
    handleChangeDescription,
    handleChangeName,
    handleChangePhoto,
    handleChangeTimeToDo,
    isLoadingImage,
    t,
  } = useMenuInformerCreateDishModalStep1();

  return (
    <div className={s.feature}>
      <Container label={t('Название')} required>
        <LangInput
          value={dish?.name}
          onChange={handleChangeName}
          name="name"
          ref={focusRef}
          data-testid="name-input"
        />
      </Container>
      <Container label={t('Описание')}>
        <LangInput
          value={dish?.specs?.full_desc}
          onChange={handleChangeDescription}
          data-testid="description-input"
        />
      </Container>

      <Label label={t('Изображение')} />
      <InputFileSquare
        types={['image/*']}
        onChange={handleChangePhoto}
        src={dish?.images?.main?.thumbnail || dish?.images?.main?.normal || mockImage}
        deletable={!!dish?.images?.main?.thumbnail || !!dish?.images?.main?.normal}
        wrapperClassName={s.image}
        isLoading={isLoadingImage}
        data-testid="image-input"
      />
      <Container label={t('Время подачи (минуты)')} required>
        <Input
          type="number"
          value={dish?.specs?.cooking_time_to}
          onChange={handleChangeTimeToDo}
          data-testid="time-to-do-input"
        />
      </Container>
      <Container label={t('Стоимость')} required>
        <Input
          onChange={handleChangeActualCost}
          value={dish?.prices?.primary?.price}
          name="actual"
          type="number"
          data-testid="actual-cost-input"
        />
      </Container>
    </div>
  );
};
